module.exports = __webpack_public_path__ + "static/media/FidelityLogo.1a71b217.svg";